import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    deleteIleggelserBilder,
    getIleggelse,
    getIleggelseBilder,
    getIleggelseHistorikk,
    putIleggelserBilder,
} from "../../../../actions/ileggelserActions";
import { bypatruljen, juridisk } from "../../../../constants/roles";
import { authorized } from "../../../../utils/authorizationUtils";
import Bilder from "../../Detalj/Bilder";

const isAuthorizedToPostAndPutBilder = () =>
  authorized([bypatruljen.saksbehandler, bypatruljen.saksbehandleradmin]);

const isAuthorizedForRediger = () =>
  authorized([
    bypatruljen.saksbehandler,
    bypatruljen.saksbehandleradmin,
    juridisk.saksbehandler,
  ]);

const isAuthorizedToDeleteImage = () =>
  authorized([
    bypatruljen.saksbehandler,
    bypatruljen.saksbehandleradmin,
    juridisk.saksbehandler,
  ]);

export default function BildContainer({
  ileggelseId,
  BilderButtonsContainer,
  checkbox,
}) {
  const ileggelse = useSelector((state) => state.ileggelse);
  const bilder = useSelector((state) => state.ileggelse?.bilder);
  const dispatch = useDispatch();

  const [thumbnailBilder, setThumbnailBilder] = useState([]);
  const [lightboxBilder, setLightboxBilder] = useState([]);
  const [bilderFallback, setBilderFallback] = useState([]);

  const fetchBilder = () => {
    dispatch(
      getIleggelseBilder(
        ileggelseId,
        null,
        { s3BucketCategory: "ileggelser_thumbnail" },
        false,
      ),
    )
      .then((tb) => setThumbnailBilder(tb))
      .catch(() => {
        // Fallback for when thumbnails are not available
        dispatch(getIleggelseBilder(ileggelseId)).then((b) =>
          setBilderFallback(b),
        );
      });

    dispatch(
      getIleggelseBilder(
        ileggelseId,
        null,
        { s3BucketCategory: "ileggelser_lightbox" },
        false,
      ),
    ).then((lb) => setLightboxBilder(lb));
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchBilder();
  }, []);

  const bildePropString = JSON.stringify(
    bilder?.map((b) => ({ id: b.id, isGoodQuality: b.isGoodQuality }))
  );
  useEffect(() => {
    fetchBilder();
  }, [bildePropString]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleDeleteImageClick = async (bildeId) => {
    await dispatch(deleteIleggelserBilder(ileggelseId, bildeId));
    dispatch(getIleggelseHistorikk(ileggelseId));
    await dispatch(getIleggelse(ileggelseId));
  };

  const handleCheckboxChange = (event) => {
    const bildeId = event.target.id;
    const bildeGoodQuality = event.target.checked;

    if (thumbnailBilder.length > 0) {
      setThumbnailBilder((prev) =>
        prev.map((bild) =>
          bild.id === bildeId
            ? { ...bild, isGoodQuality: bildeGoodQuality }
            : bild,
        ),
      );
    } else {
      setBilderFallback((prev) =>
        prev.map((bild) =>
          bild.id === bildeId
            ? { ...bild, isGoodQuality: bildeGoodQuality }
            : bild,
        ),
      );
    }

    dispatch(
      putIleggelserBilder(ileggelse.id, event.target.id, event.target.checked),
    )
      .then(() => dispatch(getIleggelseHistorikk(ileggelseId)))
      .catch(() => {
        if (thumbnailBilder.length > 0) {
          setThumbnailBilder((prev) =>
            prev.map((bild) =>
              bild.id === bildeId
                ? { ...bild, isGoodQuality: bildeGoodQuality }
                : bild,
            ),
          );
        } else {
          setBilderFallback((prev) =>
            prev.map((bild) =>
              bild.id === bildeId
                ? { ...bild, isGoodQuality: bildeGoodQuality }
                : bild,
            ),
          );
        }
      });
  };

  const isLoadingImages = () =>
    (thumbnailBilder.length > 0 &&
      lightboxBilder &&
      ileggelse &&
      ileggelse.bilder &&
      thumbnailBilder.length !== ileggelse.bilder.length &&
      lightboxBilder.length !== ileggelse.bilder.length) ||
    (bilderFallback.length > 0 &&
      ileggelse &&
      bilderFallback.length !== ileggelse.bilder.length);

  const imageArray =
    thumbnailBilder.length > 0 ? thumbnailBilder : bilderFallback;
  const lightboxImages =
    lightboxBilder.length > 0 ? lightboxBilder : bilderFallback;

  if (checkbox && isAuthorizedToPostAndPutBilder()) {
    return (
      <section className="detalj-ileggelse-section-margin">
        <Bilder
          id={ileggelseId}
          bilderButtonsContainer={
            isAuthorizedToPostAndPutBilder() ? BilderButtonsContainer : null
          }
          isLoadingImages={isLoadingImages()}
          imageArray={imageArray}
          lightboxImages={lightboxImages}
          handleDeleteImageClick={handleDeleteImageClick}
          handleCheckboxChange={handleCheckboxChange}
          checkboxText={"Til ettersendelse"}
          isAuthorizedForRediger={isAuthorizedForRediger()}
          isAuthorizedToDeleteImage={isAuthorizedToDeleteImage()}
        />
      </section>
    );
  }
  return (
    <section className="detalj-ileggelse-section-margin">
      <Bilder
        id={ileggelseId}
        bilderButtonsContainer={
          isAuthorizedToPostAndPutBilder() ? BilderButtonsContainer : null
        }
        isLoadingImages={isLoadingImages()}
        handleDeleteImageClick={handleDeleteImageClick}
        imageArray={imageArray}
        lightboxImages={lightboxImages}
        isAuthorizedForRediger={isAuthorizedForRediger()}
      />
    </section>
  );
}

BildContainer.propTypes = {
  ileggelseId: PropTypes.string.isRequired,
  BilderButtonsContainer: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]),
  checkbox: PropTypes.bool,
};
